import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowPathClockwiseOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="m9.313 3.33-1.84-1.84.99-.99L12 4.037 8.463 7.574l-.99-.99L9.327 4.73H8c-1.906 0-2.979.627-3.606 1.39-.666.811-.994 1.977-.994 3.295s.328 2.483.994 3.295c.627.763 1.7 1.39 3.606 1.39s2.979-.627 3.606-1.39c.666-.812.994-1.978.994-3.295v-.002H14v.002c0 3.042-1.5 6.085-6 6.085s-6-3.043-6-6.085C2 6.372 3.5 3.33 8 3.33z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowPathClockwiseOutlinedSize16Glyph.displayName = 'ArrowPathClockwiseOutlinedSize16Glyph';
